import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
  size?: "small" | "medium" | "large";
  showRank?: boolean;
  rank?: number;
}

export default function ComicCard({ comic, size = "medium", showRank = false, rank }: ComicCardProps) {
  const coverSizes = {
    small: "w-[120px] h-[168px]",
    medium: "w-[160px] h-[224px]",
    large: "w-[200px] h-[280px]",
  };

  const titleSizes = {
    small: "text-sm",
    medium: "text-[15px]",
    large: "text-base",
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg mb-3">
        <div className={`${coverSizes[size]} w-full aspect-[5/7] bg-background-200/70 rounded-lg overflow-hidden relative`}>
          <img
            src={comic.cover}
            alt={`${comic.title} - 韩漫在线韩国漫画`}
            title={`${comic.title} - 免费韩国漫画在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          {showRank && rank && (
            <div className="absolute top-0 left-0 w-8 h-8 bg-primary-500 flex items-center justify-center rounded-br-lg">
              <span className="text-background-50 text-sm font-bold">{rank}</span>
            </div>
          )}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <div className="flex items-center gap-2">
              <span className="text-xs text-background-50 bg-primary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">
                {comic.status}
              </span>
              <span className="text-xs text-background-50/80 whitespace-nowrap">
                {comic.chapters.length}话
              </span>
            </div>
          </div>
        </div>
      </div>
      <h3 className={`${titleSizes[size]} font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1`}>
        {comic.title}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-foreground-500">{comic.author}</span>
        <span className="text-foreground-300 text-xs">·</span>
        <div className="flex items-center gap-0.5">
          <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center"></i>
          <span className="text-xs text-foreground-500">{comic.rating}</span>
        </div>
      </div>
    </Link>
  );
}